var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from "react";
import breakouts from "../breakouts";
import { largeVideoModal, ModalVideo } from "../booths/common";
import { getUserData } from "../../../config/common";
var keynoteLinks = [
    {
        userData: getUserData(),
        background: "https://assets.swoogo.com/uploads/full/2188087-636d219ed31bb.jpg",
        name: "Keynote",
        links: [
            {
                width: "14.2%",
                height: "5.4%",
                left: "42.9%",
                top: "92.6%",
                label: "Back to Atrium",
                href: "/Atrium"
            },
            {
                width: "65.3%",
                height: "8.1%",
                left: "17.5%",
                top: "7.7%",
                label: "Mo Gawdat: Scarry Smart: The future of technology, AI, robotics and ethics",
                isExternal: true,
                modalOverrides: largeVideoModal,
                modal: React.createElement(ModalVideo, { url: "https://player.vimeo.com/video/768439769?h=2221e918e0&autoplay=1" })
            },
            {
                width: "65.3%",
                height: "8.1%",
                left: "17.5%",
                top: "16%",
                label: "Toomas Ilves: The Challenge of Today Global Digital Stage",
                isExternal: true,
                modalOverrides: largeVideoModal,
                modal: React.createElement(ModalVideo, { url: "https://player.vimeo.com/video/768439882?h=2923877222&autoplay=1" })
            },
        ]
    }
];
keynoteLinks.push(__assign(__assign({}, keynoteLinks[0]), { background: "https://assets.swoogo.com/uploads/full/2188088-636d219f61e38.jpg", links: __spreadArray(__spreadArray([], keynoteLinks[0].links, true), [
        {
            width: "65.3%",
            height: "8.1%",
            left: "17.5%",
            top: "33%",
            label: "Omera Khan: Accelerate or Die future proofing our supply chain",
            modalOverrides: largeVideoModal,
            modal: React.createElement(ModalVideo, { url: "https://player.vimeo.com/video/768440174?h=a60022d8f5&autoplay=1" })
        },
        {
            width: "65.3%",
            height: "8.1%",
            left: "17.5%",
            top: "41.1%",
            label: "Jamie Bartlet: The billion dolar crypto scam",
            modalOverrides: largeVideoModal,
            modal: React.createElement(ModalVideo, { url: "https://player.vimeo.com/video/768440802?h=7198ea7f89&autoplay=1" })
        },
    ], false) }));
keynoteLinks.push(__assign(__assign({}, keynoteLinks[1]), { background: "https://assets.swoogo.com/uploads/full/2188089-636d219fc872a.jpg", links: __spreadArray(__spreadArray([], keynoteLinks[1].links, true), [
        {
            width: "65.3%",
            height: "8.1%",
            left: "17.5%",
            top: "59.1%",
            label: "Margaret Heffernan: You Have the Attention of the Board. Now What? Navigating an uncertain future",
            modalOverrides: largeVideoModal,
            modal: React.createElement(ModalVideo, { url: "https://player.vimeo.com/video/768441071?h=8b7e68daec&autoplay=1" })
        },
        {
            width: "65.3%",
            height: "8.1%",
            left: "17.5%",
            top: "67.2%",
            label: "Rahaf Harfoush: Leading Through Emerging Technology and Digital Culture",
            modalOverrides: largeVideoModal,
            modal: React.createElement(ModalVideo, { url: "https://player.vimeo.com/video/768441391?h=d2209acdea&autoplay=1" })
        },
    ], false) }));
var Current = function (_a) {
    var location = _a.location, days = _a.days;
    var getCurrentDay = function () {
        var now = new Date();
        if (now < new Date("2022-11-15 08:00:00 UTC"))
            return 0;
        if (now >= new Date("2022-11-15 08:00:00 UTC") && now < new Date("2022-11-16 08:00:00 UTC"))
            return 0;
        if (now >= new Date("2022-11-16 08:00:00 UTC") && now < new Date("2022-11-16 18:00:00 UTC"))
            return 1;
        if (now >= new Date("2022-11-16 18:00:01 UTC"))
            return 2;
    };
    var day = getCurrentDay();
    return {
        location: location,
        body: (day === null ? days[0] : days[day])
    };
};
export var Keynote = Current({ location: "/Keynote", days: keynoteLinks });
export var Breakout = Current({ location: "/Breakout", days: breakouts });
